import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';

interface GuessTheNumberVisualizationProps {
  responseRangeMin: number;
  responseRangeMax: number;
  responseRangeScale: number;
  correctAnswerRange: {
    min: number;
    max: number;
  };
}

export const GuessTheNumberVisualization = ({
  responseRangeMin,
  responseRangeMax,
  responseRangeScale,
  correctAnswerRange,
}: GuessTheNumberVisualizationProps) => {
  return (
    <FullSizeContainer>
      {(width, height) => (
        <Box
          width={width}
          height={height}
          alignItems="center"
          justifyContent="center"
          bg="primaryWeak"
        >
          <Text fontSize="300" color="onPrimaryWeak">
            Min: {responseRangeMin}
            <br />
            Max: {responseRangeMax}
            <br />
            Scale: {responseRangeScale}
            <br />
            Correct Answer range: {correctAnswerRange.min} -{' '}
            {correctAnswerRange.max}
          </Text>
        </Box>
      )}
    </FullSizeContainer>
  );
};
